import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BnamesService {
    /**
     * Get All Bnames Api
     * @param chain
     * @param limit Limit the number of results
     * @param offset Offset the results
     * @param searchTerm
     * @param ownerIdList
     * @returns LimitOffsetResponse Successful Response
     * @throws ApiError
     */
    static getAllBnamesApiAdminBnamesGet(chain, limit = 50, offset, searchTerm, ownerIdList) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/bnames',
            query: {
                'chain': chain,
                'limit': limit,
                'offset': offset,
                'search_term': searchTerm,
                'owner_id_list': ownerIdList,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Duplicate Sub Chain Stores To Chain
     * @param chain
     * @param subChain
     * @param targetChain
     * @returns any Successful Response
     * @throws ApiError
     */
    static duplicateSubChainStoresToChainSubchainDuplicateStoresPost(chain, subChain, targetChain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subchain/duplicate/stores',
            query: {
                'chain': chain,
                'sub_chain': subChain,
                'target_chain': targetChain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Bnames Api
     * @param limit Limit the number of results
     * @param offset Offset the results
     * @param searchTerm
     * @param ownerIdList
     * @returns LimitOffsetResponse Successful Response
     * @throws ApiError
     */
    static getAllBnamesApiBnamesGet(limit = 50, offset, searchTerm, ownerIdList) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bnames',
            query: {
                'limit': limit,
                'offset': offset,
                'search_term': searchTerm,
                'owner_id_list': ownerIdList,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Bname
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createBnameBnamesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bnames',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Bname
     * @param bnameId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateBnameBnamesBnameIdPut(bnameId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/bnames/{bname_id}',
            path: {
                'bname_id': bnameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Bname
     * @param bnameId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteBnameBnamesBnameIdDelete(bnameId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/bnames/{bname_id}',
            path: {
                'bname_id': bnameId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Upload Bnames
     * Bulk upload endpoint for bnames. It accepts a csv file with the following columns:
     * id, name, address, lat, long, owner_id
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkUploadBnamesBnamesBulkUploadPost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bnames/bulk/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Upload Bnames V2
     * Bulk upload endpoint for bnames. It accepts a csv file with the following columns:
     * id, name, address, lat, long, owner_id
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkUploadBnamesV2BnamesBulkUploadV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bnames/bulk/upload/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Download Bnames
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDownloadBnamesBnamesBulkDownloadGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bnames/bulk/download',
        });
    }
    /**
     * Bulk Download Bnames V2
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDownloadBnamesV2BnamesBulkDownloadV2Get(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bnames/bulk/download/v2',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Delete Bnames
     * Bulk delete endpoint for bnames. It accepts a csv file with the following columns:
     * id
     *
     * @column id: The id of the bname to be deleted
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDeleteBnamesBnamesBulkDeletePost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bnames/bulk/delete',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Digital Stores For Bname
     * This endpoint is used to get all digital stores for a bname.
     * @param bnameId
     * @returns DigitalStoreFlat Successful Response
     * @throws ApiError
     */
    static digitalStoresForBnameBnamesBnameIdDigitalStoresGet(bnameId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bnames/{bname_id}/digital_stores',
            path: {
                'bname_id': bnameId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remap Digital Stores
     * This endpoint is used to remap all digital stores to a new bname.
     * @param bnameId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static remapDigitalStoresBnamesMapBnameIdPut(bnameId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/bnames/map/{bname_id}',
            path: {
                'bname_id': bnameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Move Bnames To Chain
     * @param chain
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static moveBnamesToChainBnamesMovePost(chain, formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bnames/move',
            query: {
                'chain': chain,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
